import React, { useMemo, useState } from "react";
import Select from "react-select";
import { OPTIONS, STATUS_OPTIONS } from "./config";
import EmployeeFilterDropdown from "components/Common/Dropdowns/EmployeeFilterDropdown";

const TARGET_TYPE_OPTIONS = [
  { key: "MONTHLY", value: "Monthly" },
  { key: "QUARTERLY", value: "Quarterly" },
  { key: "YEARLY", value: "Yearly" },
];

const getFinancialYearOptions = () => {
  const currentYear = new Date().getFullYear();
  const years = [];

  for (let i = currentYear - 3; i <= currentYear + 2; i++) {
    years.push({
      key: `${i}-${(i + 1).toString().slice(-2)}`,
      value: `${i}-${(i + 1).toString().slice(-2)}`,
    });
  }

  return years;
};

const Filter = (props) => {
  const { filters, updateFilter, updateMultipleFilters } = props;
  const [searchText, setSearchText] = useState(filters.text || "");

  const onDropdownChange = (value) => {
    updateMultipleFilters({
      keyword: value,
      text: searchText,
    });
  };

  const onSearchChange = (event) => {
    const { value } = event.target;
    setSearchText(value);
    updateFilter("text", value.trim() === "" ? "" : value);
  };

  const setFilterValue = (keyname, value) => {
    updateFilter(keyname, value);
  };

  const filterVal = useMemo(() => {
    return (
      OPTIONS.find((option) => option.key === filters.keyword)?.value || ""
    );
  }, [filters]);

  const statusVal = useMemo(() => {
    return (
      STATUS_OPTIONS.find((option) => option.key === filters.is_active)
        ?.value || ""
    );
  }, [filters]);

  const targetTypeOptionsFormatted = useMemo(
    () =>
      TARGET_TYPE_OPTIONS.map((opt) => ({
        label: opt.value,
        value: opt.key,
      })),
    [],
  );

  const financialYearOptions = useMemo(() => getFinancialYearOptions(), []);

  const financialYearOptionsFormatted = useMemo(
    () =>
      financialYearOptions.map((opt) => ({
        label: opt.value,
        value: opt.key,
      })),
    [financialYearOptions],
  );

  const selectedTargetType = targetTypeOptionsFormatted.find(
    (opt) => opt.value === filters.target_type,
  );

  const selectedFinancialYear = financialYearOptionsFormatted.find(
    (opt) => opt.value === filters.financial_year,
  );

  return (
    <>
      <div className="dropdown ms-3">
        <button
          className="dropdown-toggle btn active"
          data-bs-toggle="dropdown"
        >
          {statusVal}
        </button>
        <ul className="dropdown-menu">
          {STATUS_OPTIONS.map(({ key, value }) => (
            <li
              className="dropdown-item"
              onClick={() => updateFilter("is_active", key)}
              key={key}
            >
              {value}
            </li>
          ))}
        </ul>
      </div>

      <div className="ms-3" style={{ minWidth: 180 }}>
        <Select
          placeholder="Target Type"
          options={targetTypeOptionsFormatted}
          value={selectedTargetType || null}
          onChange={(selected) =>
            updateFilter("target_type", selected?.value || "")
          }
          isClearable
        />
      </div>

      <div className="ms-3" style={{ minWidth: 180 }}>
        <Select
          placeholder="Financial Year"
          options={financialYearOptionsFormatted}
          value={selectedFinancialYear || null}
          onChange={(selected) =>
            updateFilter("financial_year", selected?.value || "")
          }
          isClearable
        />
      </div>

      <div style={{ width: "250px" }} className="ms-3">
        <EmployeeFilterDropdown
          setFilterValue={setFilterValue}
          selectedValue={filters.employee_code_id}
          className="w-100"
        />
      </div>
    </>
  );
};

export default Filter;
